import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {AppState} from '../Store';

interface AdminLinkProps {
  to: string;
  text: string;

  admin: boolean;
}

function AdminLink({to, text, admin}: AdminLinkProps)  {
  if (!admin) {
    return null;
  }

  return (
    <Link className="float-left" to={to}>
      {text}
    </Link>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    admin: state.auth.admin,
  };
};

export default connect(mapStateToProps)(AdminLink);
